/**
 * Product Hero Section JavaScript
 * 支持动态内容绑定与交互
 */

document.addEventListener('DOMContentLoaded', function() {
  const heroSection = document.getElementById('section-hero');
  
  if (!heroSection) return;

  // 监听自定义界面变更（用于 Shopify 编辑器）
  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail.sectionId === 'hero') {
      // 重新初始化或刷新背景
      console.log('Hero section reloaded');
    }
  });

  // 可选：添加视差滚动效果
  window.addEventListener('scroll', function() {
    const scrollPos = window.scrollY;
    if (scrollPos < 1000) {
      heroSection.style.backgroundPosition = `center ${scrollPos * 0.5}px`;
    }
  });
});
